module.exports = __webpack_public_path__ + "static/media/S3N10-4.93586e18.svg";